import * as React from 'react'

import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'

import { MainArea }          from '../components/templates'
import { Routing, TopRoute } from '../types'
import { memoize }           from '../utils'

const renderComponent = memoize((name, component) => {
  return () => (
    <MainArea
      component={component}
      title={name}
    />
  )
})

const TopRichRoute = ({
  path,
  subrouting,
}: TopRoute) => (
  <Route
    key={path}
    path={path}
    render={({ match }: any) => (
      <Switch>
        {subrouting.map((route) => (
          <Route
            key={route.path}
            path={match.url + route.path}
            render={renderComponent(route.name, route.component)}
          />
        ))}
        {
          /*
           i chose to just redirect to the first subroute of a
           top-route if someone navigated here with a non-matching path
           */
        }
        <Redirect
          to={
            match.url
            + subrouting[ 0 ].path
          }
        />
      </Switch>
    )}
  />
)

export default ({ routing }: { routing: Routing }) => {
  return (
    <Switch>
      {routing.map(TopRichRoute)}
      {/* same here (see comment above TopRichRoute's Redirect) */}
      <Redirect to={routing[ 0 ].path} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/routing/NavigationManager.tsx